<template>
  <div class="bookTable">
    <el-row :gutter="20">
      <el-col :span="16">
        <el-input size="mini" v-model="isbnNumber" style="width:200px;" placeholder="ISBN号"></el-input>
        <el-input size="mini" v-model="bookName" style="width:200px;" placeholder="书籍名称"></el-input>
        <el-input size="mini" v-model="publisherName" style="width:200px;" placeholder="出版社名称"></el-input>
        <el-select size="mini" v-model="goodsType" placeholder="请选择" style="width:100px;">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-button @click="handleQuery" size="mini">查询</el-button>
        <el-button @click="handleReset" size="mini">重置</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="gridData" border highlight-current-row @current-change="handleCurrentChange" max-height="270">
        <el-table-column property="isbn" label="ISBN号" width="150"></el-table-column>
        <el-table-column property="title" label="书籍名称" width="200"></el-table-column>
        <el-table-column property="publisher" label="出版社名称"></el-table-column>
        <el-table-column property="author" label="作者" width="150"></el-table-column>
        <el-table-column property="goodsType" :formatter="formatterValue" label="类型" width="150"></el-table-column>
        <el-table-column property="price" label="定价" width="150"></el-table-column>
      </el-table>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancle" size="mini">取 消</el-button>
      <el-button type="primary" @click="handleOk" size="mini">确认选择</el-button>
    </span>
  </div>
</template>
<script>
import { bookSelectList,bookQueryList } from "@/api/sysinfo";
export default {
  data() {
    return {
      gridData: [],
      currentRow: {},
      goodsKey: {
        1: "纸质书",
        2: "电子书",
        3: "非书籍"
      },
      isbnNumber: "",
      bookName: "",
      publisherName: "",
      goodsType: "",
      options: [
        {
          value: 1,
          label: "纸质书"
        },
        {
          value: 2,
          label: "电子书"
        },
        {
          value: 3,
          label: "非书籍"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleCancle() {
      this.$emit("close");
    },
    handleOk() {
      this.$emit("close", this.currentRow);
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    //   console.log(this.currentRow);
    },
    // 查询
    handleQuery() {
      let params = {
        goodsType: this.goodsType,
        title: this.bookName,
        publisher: this.publisherName,
        isbn: this.isbnNumber
      };
      bookQueryList(params).then(data => {
        this.gridData = data.data;
      });
    },
    // 重置
    handleReset() {
      this.isbnNumber = "";
      this.bookName = "";
      this.publisherName = "";
      this.goodsType = "";
    },
    // 获取书籍选择列表数据
    getData() {
      let params = {};
      bookSelectList(params).then(data => {
        this.gridData = data.data.list;
      });
    },
    // 数据格式化
    formatterValue(row, col) {
      let rowValue = row.goodsType;
      return this.goodsKey[rowValue];
    }
  }
};
</script>
<style lang="scss">
.bookTable{

.el-table td,.el-table th{
    padding:5px 0px;
}
.el-table .cell{
    font-size:12px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

}
</style>


// WEBPACK FOOTER //
// src/views/Components/BookSelect.vue